
export default function TargetSection() {
  const targets = [
    {
      icon: 'ri-building-line',
      title: 'PMI e Grandi Imprese',
      description: 'Aziende che vogliono valorizzare il proprio brand e patrimonio intangibile per crescere sul mercato',
    },
    {
      icon: 'ri-exchange-funds-line',
      title: 'M&A e Investitori',
      description: 'Operazioni di fusione, acquisizione o investimento che richiedono valutazioni certificate',
    },
    {
      icon: 'ri-bank-line',
      title: 'Istituti Finanziari',
      description: 'Banche e società finanziarie per valutazioni patrimoniali e operazioni di credito',
    },
    {
      icon: 'ri-scales-3-line',
      title: 'Studi Professionali',
      description: 'Commercialisti, avvocati e consulenti che necessitano di perizie certificate',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-32 bg-gradient-to-b from-white to-[#F8F9FA]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16 lg:mb-20">
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0B1F3B] mb-4 sm:mb-6">
            A Chi Ci Rivolgiamo
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-[#1C1C1C]/70 max-w-3xl mx-auto leading-relaxed px-4">
            Supportiamo diverse tipologie di clienti nella valorizzazione del brand nel patrimonio aziendale
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
          {targets.map((target, index) => (
            <div
              key={index}
              className="bg-white p-6 sm:p-8 rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 text-center group"
            >
              <div className="w-16 h-16 sm:w-20 sm:h-20 mx-auto mb-4 sm:mb-6 flex items-center justify-center bg-[#E879F9]/5 rounded-full group-hover:bg-[#E879F9]/10 transition-colors">
                <i className={`${target.icon} text-4xl sm:text-5xl text-[#E879F9]`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-[#0B1F3B] mb-3 sm:mb-4">
                {target.title}
              </h3>
              <p className="text-sm sm:text-base text-[#1C1C1C]/70 leading-relaxed">
                {target.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
